/*
  import { mailingDeliveryStore } from '@/services/MailingManagement/Mailing/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import { notifyError, notifyMessage } from '@/services/notify'
import kms from '@/services/kms'

const actions = {
  async deliverMailingItemImmediately({ dispatch }, { payload, done }) {
    console.debug('...in deliverMailingItemImmediately')
    try {
      const results = await kms.post(
        `/Mailings/Mailing/DeliverMailingItemImmediately?mailingID=${payload.mailingID}`
      )

      if (this.isDebug == true) console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      if (results.mailingID) {
        notifyMessage(`Successfully delivered the mailing items.`)
        done()
      } else {
        notifyError('There was a problem delivering this mailing.')
      }
    } catch (exception) {
      notifyError(`There was a problem delivering this mailing.`)
      console.error(exception)
    }
  },

  async deliverMailingDeliveryItemsImmediately({ dispatch }, { payload, done }) {
    console.debug('...in deliverMailingDeliveryItemsImmediately')
    try {
      const results = await kms.post(
        `/Mailings/Mailing/DeliverMailingItemImmediately?mailingDeliveryItemID=${payload.mailingDeliveryItemID}`
      )

      console.debug('deliverMailingDeliveryItemsImmediately results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      if (results.mailingID) {
        notifyMessage(`Successfully delivered the mailing delivery item.`)
        done()
      } else {
        notifyError('There was a problem delivering this mailing delivery item.')
      }
    } catch (exception) {
      notifyError(`There was a problem delivering this mailing delivery item.`)
      console.error(exception)
    }
  }
}

Vue.use(Vuex)
export const mailingDeliveryStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
